import { caseSelector } from './case';
import { missionSelector } from './mission';

export const dataSelector = state => {
  const missionData = missionSelector(state);
  return missionData.missionOrderId ? missionData : caseSelector(state);
};

export const languageSelector = state => dataSelector(state)?.preferredLanguage;
